import { render, staticRenderFns } from "./lcu-button.vue?vue&type=template&id=5024e4be&scoped=true&"
import script from "./lcu-button.vue?vue&type=script&lang=ts&"
export * from "./lcu-button.vue?vue&type=script&lang=ts&"
import style0 from "./lcu-button.vue?vue&type=style&index=0&id=5024e4be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024e4be",
  null
  
)

export default component.exports